import React, { Component } from "react";
import DashboardHeader from "../../components/dashboardheader/dashboardheader";
import Finxfooter from "../finxfooter/finxfooter";
import { connect } from "react-redux";
import {
  getproductDetailsAll,
  getproductDetailsAllPending
} from "../../reducer/productDetailsAllReducer";
import { getProductType } from "../../reducer/productProductTypeReducer";

import { getPartner } from "../../reducer/productPartnerReducer";
import { getStatus } from "../../reducer/productStatusReducer";
import { getHasModule } from "../../reducer/productHasModuleReducer";

import { bindActionCreators } from "redux";
import AddProduct from "../../components/product/addProduct";
import EditProduct from "../../components/product/editProduct";

import {
  fetchProductTypeData,
  fetchPartnerData,
  fetchStatusData,
  fetchHasModuleData
} from "../../services/fetchLearnerDashboard.service";

import { LoginService } from "../../services/login.service";
import { getPersonnelAddressData } from "../../reducer/userProfileReducer";
import { RegisterUserService } from "../../services/registration.service";
import { fetchRoles } from "../../services/fetchRoles";
import { getRoles } from "../../reducer/roleReducer";

import { ProductService } from "../../services/product.service";

import AdminHeader from "../../components/dashboardheader/adminheader";
import $ from "jquery";
import { from } from "linq";
import { getAlertNotificationEvents, getAlertNotificationEventsPending, getAlertNotificationEventsError } from "../../reducer/alertsNotificationReducer";
import { getNotificationEvents, getNotificationEventsPending, getNotificationEventsError } from "../../reducer/notificationReducer";
import { fetchAlertNotificationEvents, fetchNotificationEvents } from "../../services/fetchLearnerDashboard.service";


//productType is used for binding producttype dropdown
//fetchProductTypeData is service of binding producttype dropdown

const mapStateToProps = state => ({
  // productDetailsAll: getproductDetailsAll(state.productDetailsAllReducer),
  // productDetailsAllPending: getproductDetailsAllPending(state.productDetailsAllReducer),
  // addressData: getPersonnelAddressData(state.userProfileReducers),
  roles: getRoles(state.roleReducer),
  productType: getProductType(state.productProductTypeReducer),
  partner: getPartner(state.productPartnerReducer),
  status: getStatus(state.productStatusReducer),
  hasModule: getHasModule(state.productHasModuleReducer),
  alertNotificationEvents: getAlertNotificationEvents(
    state.alertNotificationEventsReducer
  ),
  pendingAlertNotificationEvents: getAlertNotificationEventsPending(
    state.alertNotificationEventsReducer
  ),
  errorAlertNotificationEvents: getAlertNotificationEventsError(
    state.alertNotificationEventsReducer
  ),

  notificationEvents: getNotificationEvents(state.notificationEventsReducer),
  pendingNotificationEvents: getNotificationEventsPending(
    state.notificationEventsReducer
  ),
  errorNotificationEvents: getNotificationEventsError(
    state.notificationEventsReducer
  ),

});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchProductTypeData: fetchProductTypeData,
      fetchPartnerData: fetchPartnerData,
      fetchStatusData: fetchStatusData,
      fetchHasModuleData: fetchHasModuleData,
      fetchRoles: fetchRoles,
      fetchAlertNotificationEvents: fetchAlertNotificationEvents,
      fetchNotificationEvents: fetchNotificationEvents,
    },
    dispatch
  );

const connectFunction = connect(mapStateToProps, mapDispatchToProps);

const productAddList = connectFunction(
  class extends Component {
    constructor(props) {

      super(props);
      this.state = {
        productType: [],
        partner: [],
        status: [],
        hasModule: []
      };
    }

    componentDidUpdate() { }

    componentDidMount() {
      const {
        fetchProductTypeData,
        fetchPartnerData,
        fetchStatusData,
        fetchHasModuleData,
        fetchRoles,
        fetchAlertNotificationEvents,
        fetchNotificationEvents,
      } = this.props;
      let partyID = localStorage.getItem("userid-Token");
      LoginService.TokenUser(res => {
        localStorage.setItem("jwt-token", res.responseObject);
      });

      fetchAlertNotificationEvents();
      fetchNotificationEvents("partyId=" + partyID);

      LoginService.TokenUser(res => {
        if (res.status === "success") {
          localStorage.setItem("jwt-token", res.responseObject);

          let productType = "codeTypeName=product_type";
          fetchProductTypeData(productType, res => {
            //console.log("PRODUCT TYPE DATA", res);
          });
        }
      });
      LoginService.TokenUser(res => {

        if (res.status === "success") {
          localStorage.setItem("jwt-token", res.responseObject);

          fetchPartnerData(res => {
            //console.log("PARTNER DATA", res);
          });
        }
      });
      LoginService.TokenUser(res => {

        if (res.status === "success") {
          localStorage.setItem("jwt-token", res.responseObject);

          fetchStatusData(res => {
            //console.log("Status DATA", res);
          });
        }
      });
      LoginService.TokenUser(res => {

        if (res.status === "success") {
          localStorage.setItem("jwt-token", res.responseObject);

          fetchHasModuleData(res => {
            //console.log("HasModule DATA", res);
          });
        }
      });
    }

    render() {

      const {
        productDetailsAll,
        productDetailsAllPending,
        productType,
        partner,
        status,
        hasModule,
        roles,
        alertNotificationEvents,
        pendingAlertNotificationEvents,
        errorAlertNotigicationEvents,
        notificationEvents,
        pendingNotificationEvents,
        errorNotificationEvents,
      } = this.props;

      //console.log("productType", productType);
      //console.log("partner", partner);
      //console.log("Status", status);
      //console.log("HASMODULE", hasModule);
      if (!productType.length) {
        return null;
      } else {
        return (
          <React.Fragment>
            <AdminHeader
              //alertNotificationEvents={alertNotificationEvents}
              //notificationEvents={notificationEvents}
              {...this.props}
            />
            <AddProduct
              productDetailsAll={productDetailsAll}
              productType={productType}
              partner={partner}
              status={status}
              hasModule={hasModule}
              fetchProductTypeData={fetchProductTypeData}
              roles={roles}
              {...this.props}
            />

            <Finxfooter />
          </React.Fragment>
        );
      }
    }
  }
);

export default productAddList;
